import { render, staticRenderFns } from "./EmailSender.vue?vue&type=template&id=381445af&scoped=true"
import script from "./EmailSender.vue?vue&type=script&lang=js"
export * from "./EmailSender.vue?vue&type=script&lang=js"
import style0 from "./EmailSender.vue?vue&type=style&index=0&id=381445af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381445af",
  null
  
)

export default component.exports